import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import './FixedCallButton.css';

const FixedCallButton = () => {
    const phoneNumber = "+905445240040";
    const phoneNumber2 = "+908508079898"
    const message = encodeURIComponent("Merhaba! Fiber internet kampanyaları hakkında bilgi almak istiyorum");
    const whatsappUrl = `https://wa.me/${phoneNumber.replace('+', '')}?text=${message}`;

    return (
        <div className="fixed-buttons-container">
            <a
                href={whatsappUrl}
                className="whatsapp-button"
                target="_blank"
                rel="noopener noreferrer"
            >
                <div className="whatsapp-ikon-daire">
                    <FaWhatsapp className="whatsapp-icon" />
                    <div className="halka halka-1"></div>
                    <div className="halka halka-2"></div>
                </div>
                <div className="yazi-bolgesi">
                    <span className="ana-baslik">FİBER İNTERNETİM</span>
                    <span className="telefon-numarasi">WhatsApp</span>
                </div>
            </a>

            <a href={`tel:${phoneNumber2}`} className="bize-ulasin-buton">
                <div className="telefon-ikon-daire">
                    <FaPhoneAlt className="phone-icon" />
                    <div className="halka halka-1"></div>
                    <div className="halka halka-2"></div>
                </div>
                <div className="yazi-bolgesi">
                    <span className="ana-baslik">FİBER İNTERNETİM</span>
                    <span className="telefon-numarasi">Hemen Ara</span>
                </div>
            </a>
        </div>
    );
};

export default FixedCallButton;